import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { Sidebar } from '../components/Sidebar';
import { Topbar, TopbarSlotProvider } from '../components/Topbar';
import { getCurrentManager } from '../features/auth';

/*
 * Layout рабочего места: сайдбар слева, справа колонка «топбар + страница».
 * Прокручивается только страница, топбар и сайдбар стоят на месте.
 *
 * Проверка входа стоит в beforeLoad, а не внутри компонента: маршрут отваливается
 * до рендера и до запросов, лишней отрисовки не происходит.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: () => {
    if (!getCurrentManager()) throw redirect({ to: '/login' });
  },
  component: () => (
    <TopbarSlotProvider>
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar />
          <main className="flex-1 overflow-y-auto px-8 pt-7 pb-20">
            <Outlet />
          </main>
        </div>
      </div>
    </TopbarSlotProvider>
  ),
});
